import RelationshipMetadata from "../../RelationshipMetadata";

class EmployeeEmployeeAdminRoleRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "EmployeeEmployeeAdminRoleRelationshipMetadata";
        this.parentEnterpriseComponent = "Employee";
        this.childEnterpriseComponent = "EmployeeAdminRole";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "RoleUSID";
    }
}

export default EmployeeEmployeeAdminRoleRelationshipMetadata;